export const appHead = {"link":[{"rel":"preconnect","href":"https://fonts.googleapis.com"},{"rel":"preconnect","href":"https://prediction.xgen.dev/"},{"rel":"preconnect","href":"https://assets.xgen.dev/"},{"rel":"preconnect","href":"https://8eurk2.us"},{"rel":"preconnect","href":"https://www.googletagmanager.com/"},{"rel":"preconnect","href":"https://www.gstatic.com/"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon-180.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"/apple-touch-icon-120x120.png"},{"rel":"apple-touch-icon","href":"/apple-touch-icon.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"/apple-touch-icon-120x120-precomposed.png"},{"rel":"icon","type":"image/svg+xml","href":"/favicon.svg"},{"rel":"preconnect","href":"https://cdn.cookielaw.org/"}],"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0"},{"property":"og:type","content":"website"}],"style":[],"script":[{"innerHTML":"function OptanonWrapper() {}","type":"text/javascript"},{"innerHTML":"\n            (function() {\n              // Source of truth: integration-layer/utils/oneTrustLocales.ts (serialised at build time)\n              var notLoadCookieBanner = [\"en-au\",\"fr-be\",\"en-ca\",\"es-cl\",\"en-hk\",\"en-id\",\"en-il\",\"ja-jp\",\"ko-kr\",\"es-mx\",\"en-my\",\"en-nz\",\"en-ph\",\"en-sg\",\"en-th\",\"en-tr\",\"en-tw\",\"en-ua\",\"en-wx\",\"en-za\"];\n\n              // Determine locale and country from URL path or cookie\n              var path = window.location.pathname;\n              var localeMatch = path.match(/\\/([a-z]{2})-([a-z]{2})\\//);\n              var locale = localeMatch ? localeMatch[1] + '-' + localeMatch[2] : null;\n              var country = localeMatch ? localeMatch[2] : null;\n\n              // Fallback to cookie if path doesn't have locale\n              if (!locale) {\n                var cookieMatch = document.cookie.match(/i18n_redirected=([^;]+)/);\n                if (cookieMatch) {\n                  locale = cookieMatch[1].toLowerCase();\n                  var parts = locale.split('-');\n                  country = parts[1] || null;\n                }\n              }\n\n              // Skip loading OneTrust for locales that don't require the banner\n              if (locale && notLoadCookieBanner.indexOf(locale) !== -1) {\n                return;\n              }\n\n              // Set domain script based on country (US vs others)\n              var domainScript = country === 'us'\n                ? '0192b849-42e6-7972-b5cf-8308303c610c'\n                : '01919d3c-be13-74ce-a59e-ed8763aa05ee';\n\n              // Create and inject OneTrust script immediately\n              var script = document.createElement('script');\n              script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';\n              script.setAttribute('data-domain-script', domainScript);\n              script.setAttribute('data-document-language', 'true');\n              script.async = true;\n              script.fetchPriority = 'high';\n\n              var head = document.head || document.getElementsByTagName('head')[0];\n              var firstScript = head.getElementsByTagName('script')[0];\n              if (firstScript) {\n                head.insertBefore(script, firstScript);\n              } else {\n                head.appendChild(script);\n              }\n            })();\n          ","type":"text/javascript"}],"noscript":[],"htmlAttrs":{}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = true

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"trailingSlash":"append","prefetchOn":{"interaction":true,"visibility":true},"componentName":"NuxtLink","prefetch":true}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"